import axios from 'axios'

import authService from "@/services/authService";
const base = `https://members.eccourts.org`

export const getImageById = async (id) => {
  return await axios.get(`${base}/wp-json/wp/v2/media/${id}?_fields=source_url`)
}

export default {
  getMedia(id, params) {
    params = params || "";
    const token = authService.getCookie("wcmCookie");
    let url = `${base}/wp-json/wp/v2/media/${id}?${params}`;
    return axios.get(url, {
      headers: {
        Authorization: "Bearer" + token,
        "Content-Type": "multipart/form-data",
      },
    });
  },
  getMyMedia(id, token) {
    let url = `${base}/wp-json/wp/v2/media?author=${id}`;
    return axios.get(url, {
      headers: {
        Authorization: "Bearer" + token,
        "Content-Type": "multipart/form-data",
      },
    });
  },
  deleteFile(id) {
    const token = authService.getCookie("wcmCookie");
    return axios.delete(`${base}/wp-json/wp/v2/media/${id}?force=true`, {
      headers: { Authorization: "Bearer" + token },
    });
  },

  saveFile(file, fields, token, config) {
    let formData = new FormData();
    formData.append("file", file);
    fields.post ? formData.append("post", fields.post) : false;
    fields.author ? formData.append("author", fields.author) : false;
    fields.meta ? formData.append("alt_text", fields.meta) : false;

    return axios.post(`${base}/wp-json/wp/v2/media`, formData, {
      onUploadProgress(e) {
        config ? config(e) : "";
        // console.log(`e.loaded: ${e.loaded}, e.total: ${e.total}, percent: ${(e.loaded / e.total ) * 100}`);
      },
      headers: {
        Authorization: "Bearer" + token,
        "Content-Type": "multipart/form-data",
      },
    });
  },
  uploadFile(payload) {
    const token = authService.getCookie("wcmCookie");
    let formData = new FormData();

    for (const key in payload) {
      formData.append(key, payload[key]);
    }

    return axios.post(`${base}/wp-json/wp/v2/media`, formData, {
      headers: {
        Authorization: "Bearer" + token,
        "Content-Type": "multipart/form-data",
      },
    });
  },
};
